/*
 *@Author: 史泽
 *@Date: 2022-03-09 14:22:35
 *@Description: 打印
 */
export default function printAll(Element, styleSheet, arr, flag) {
  if (flag) {
    var newWin = window.open(""); //新打开一个空窗口
    for (var i = 0; i < arr.length; i++) {
      var imageToPrint = document.querySelector(Element + i); //获取需要打印的内容
      newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
    }
    newWin.document.head.innerHTML = styleSheet; //给打印的内容加上样式
    newWin.document.close(); //在IE浏览器中使用必须添加这一句
    newWin.focus(); //在IE浏览器中使用必须添加这一句
    setTimeout(function() {
      newWin.print(); //打印
      newWin.close(); //关闭窗口
    }, 1);
  } else {
    var newWin = window.open(""); //新打开一个空窗口
    var imageToPrint = document.querySelector(Element); //获取需要打印的内容
    newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
    newWin.document.head.innerHTML = styleSheet; //给打印的内容加上样式
    newWin.document.close(); //在IE浏览器中使用必须添加这一句
    newWin.focus(); //在IE浏览器中使用必须添加这一句
    setTimeout(function() {
      newWin.print(); //打印
      newWin.close(); //关闭窗口
    }, 1);
  }
}
